import type { AuthSession } from './types.js';
import type { HttpClient } from './http.js';
import type { TokenStore } from './types.js';

export function createAuthApi(http: HttpClient, tokenStore: TokenStore) {
  return {
    async requestMagicLink(email: string): Promise<void> {
      await http.json('/api/auth/magic-link', {
        method: 'POST',
        body: JSON.stringify({ email }),
      });
    },

    async verifyMagicLink(token: string): Promise<AuthSession> {
      const session = await http.json<AuthSession>('/api/auth/verify', {
        method: 'POST',
        body: JSON.stringify({ token }),
      });
      tokenStore.setSession(session);
      return session;
    },

    async refreshSession(): Promise<AuthSession | null> {
      const existing = tokenStore.getSession();
      if (!existing?.accessToken) {
        return null;
      }

      const data = await http.json<{ accessToken?: string; user?: AuthSession['user'] }>(
        '/api/auth/session',
        {
          headers: { Authorization: `Bearer ${existing.accessToken}` },
        },
      );

      if (!data.user) {
        tokenStore.setSession(null);
        return null;
      }

      const session: AuthSession = {
        accessToken: data.accessToken ?? existing.accessToken,
        user: data.user,
      };
      tokenStore.setSession(session);
      return session;
    },

    async signOut(): Promise<void> {
      const token = tokenStore.getAccessToken();
      if (token) {
        await http
          .fetch('/api/auth/logout', {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}` },
          })
          .catch(() => undefined);
      }
      tokenStore.setSession(null);
    },
  };
}
